exports = module.exports = require("../../../../../../build/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".com-lottery-button-group{margin:0 .5%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!../src/component/game-lottery/component/lottery-button-group/scss/index.scss
// module id = 806
// module chunks = 0 1